import { BadgeControl } from './badge.control';
import { BadgesConfig } from './badges-config';

export class BadgesControl {
  tabs: BadgeControl[];
  badgeConfig: BadgesConfig;

  constructor() {
    this.tabs = [];
    this.badgeConfig = new BadgesConfig();
    this.badgeConfig.cssClass = 'badge-tab';
    this.badgeConfig.hideLabel = false;
    this.badgeConfig.isClickable = true;
    this.badgeConfig.selectedBadge = -1;
  }

  addTab(badgeTitle: any, badgeLabel: string, isDataLoaded: boolean) {
    const tab = new BadgeControl();
    tab.badgeTitle = badgeTitle;
    tab.badgeLabel = badgeLabel;
    tab.isDataLoaded = isDataLoaded;
    this.tabs.push(tab);
  }
}
